// extracted by mini-css-extract-plugin
export default {"box":"Box_box__UYux2","gradient":"Box_gradient__L40Tz","header":"Box_header__+jhfx"};